import './jquery-ui-1.10.4.min.css';

import './jquery-ui.min';
import './datepicker_ru';
import './correctPopupPosition';